import React from 'react';
import {PerkTransactionSection} from './PerkTransactionSection';

export const PerkTransactionTable = ({transaction}) => {
    return (
        <tbody key={transaction['section']}>
            <tr style={{backgroundColor:'#999999'}}>
                <th colSpan="6" style={{padding: 5, paddingLeft: 10}}>{transaction['section']}</th>
            </tr>
            {transaction['data'].map(trans => <PerkTransactionSection key={trans.id} trans={trans} sectionHead={transaction['section']} />)}
        </tbody>
    );
};
